import KardiaRxCCTPatientResult from './KardiaRxCCTPatientResult';

export default KardiaRxCCTPatientResult;



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTPatientResult/index.js